// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FDvc","clinicsSelect":"styles_clinicsSelect__1VcvV"};